import type { CSSProperties, ReactNode } from 'react';
import { Icon, type IconName } from './Icon';

export type BannerTone = 'offline' | 'pending' | 'error' | 'info';

const ICON: Record<BannerTone, IconName> = {
  offline: 'cloud-offline-outline',
  pending: 'time-outline',
  error: 'alert-circle',
  info: 'information-circle-outline',
};

export interface BannerProps {
  tone?: BannerTone;
  children: ReactNode;
  action?: ReactNode;
  /** Rounded corners when the banner sits inside content rather than under the header. */
  rounded?: boolean;
  style?: CSSProperties;
}

/** Persistent, non-blocking banner. Always icon plus words. */
export function Banner({ tone = 'offline', children, action, rounded, style }: BannerProps) {
  return (
    <div
      role="status"
      className={`fw-banner fw-banner--${tone}${rounded ? ' fw-banner--rounded' : ''}`}
      style={style}
    >
      <Icon name={ICON[tone]} size={18} />
      <span className="fw-banner__text">{children}</span>
      {action}
    </div>
  );
}
